import { render, staticRenderFns } from "./DialogBox.vue?vue&type=template&id=0993dba2&scoped=true&"
import script from "./DialogBox.vue?vue&type=script&lang=js&"
export * from "./DialogBox.vue?vue&type=script&lang=js&"
import style0 from "./DialogBox.vue?vue&type=style&index=0&id=0993dba2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0993dba2",
  null
  
)

export default component.exports